"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ImageCarousel;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const ImageCarouselItem_1 = __importDefault(require("./ImageCarouselItem"));
const index_1 = require("../../index");
const hooks_1 = require("@alcumus/hooks");
const useStyles = (0, core_1.makeStyles)(() => ({
    carouselWrap: {
        display: 'flex',
    },
    carouselContainer: {
        whiteSpace: 'nowrap',
        transition: 'transform 0.3s',
        overflow: 'hidden',
    },
    carouselInner: {
        position: 'relative',
        width: '100%',
    },
    carouselButtonPrev: {
        position: 'absolute',
        top: '50%',
        left: '0%',
        border: index_1.StyleVariables.colors.base.white,
        background: 'transparent',
    },
    carouselButtonNext: {
        position: 'absolute',
        top: '50%',
        right: '0%',
        border: index_1.StyleVariables.colors.base.white,
        background: 'transparent',
    },
}));
function ImageCarousel({ images, maxItemsToDisplay = 4, imageWidth = '50%', }) {
    const classes = useStyles();
    const size = (0, hooks_1.useWindowSize)();
    const length = images.length;
    const [itemsToDisplay, setItemsToDisplay] = (0, react_1.useState)(3);
    const [maxLength, setMaxLength] = (0, react_1.useState)(1);
    const [activeIndex, setActiveIndex] = (0, react_1.useState)(0);
    const [imagePadding, setImagePadding] = (0, react_1.useState)(100 / maxLength);
    (0, react_1.useEffect)(() => {
        if (size.width === undefined) {
            setItemsToDisplay(1);
        }
        else if (size.width <= 600) {
            setItemsToDisplay(1);
        }
        else if (size.width > 600 && size.width <= 900) {
            setItemsToDisplay(2);
        }
        else {
            setItemsToDisplay(maxItemsToDisplay);
        }
        setMaxLength(length < itemsToDisplay ? length : itemsToDisplay);
        setImagePadding(100 / maxLength);
    });
    const updateIndex = (newIndex) => {
        if (newIndex < 0) {
            newIndex = length - 1;
        }
        if (newIndex >= length) {
            newIndex = 0;
        }
        setActiveIndex(newIndex);
    };
    const generateImages = () => {
        const displayImages = [];
        for (let i = activeIndex; i < activeIndex + maxLength; i++) {
            let displayIndex = i;
            if (i >= length) {
                displayIndex = i % length;
            }
            displayImages.push(react_1.default.createElement(ImageCarouselItem_1.default, { imageUrl: images[displayIndex], key: displayIndex, padding: imagePadding, imageWidth: imageWidth }));
        }
        return displayImages;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.carouselWrap },
            react_1.default.createElement("div", { className: classes.carouselInner },
                react_1.default.createElement("button", { className: classes.carouselButtonPrev, onClick: () => {
                        updateIndex(activeIndex - 1);
                    } },
                    react_1.default.createElement(index_1.OutlinedIcon, { icon: 'arrow_back_ios' })),
                react_1.default.createElement("div", { className: classes.carouselContainer }, generateImages()),
                react_1.default.createElement("button", { className: classes.carouselButtonNext, onClick: () => {
                        updateIndex(activeIndex + 1);
                    } },
                    react_1.default.createElement(index_1.OutlinedIcon, { icon: 'arrow_forward_ios' }))))));
}
